import script from "./PaymentSectionApplePay.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentSectionApplePay.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentSectionApplePay.vue?vue&type=style&index=0&id=51b4733c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51b4733c"]])

export default __exports__